__turbopack_context__.v({
  "dotSeparator": "dotseparator-module-scss-module__lCIWba__dotSeparator",
});
